/* eslint-disable no-bitwise */
/* istanbul ignore file */
import _ from 'underscore';
import Promise from 'bluebird';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { getEditorialTemplates, ENTITY } from '@bingads-webui-campaign/delivery-status-popup-factory';

const odata = globalContext.require('module/service/communication/channel/odata');
const locationI18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/location-targets');
const commonI18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/ads-tab/common');
const errI18n = globalContext.require('component/api-errors-campaign/index');
const editorialRejection = globalContext.require('component/api-errors-campaign/map/editorialRejectionFwdLinkId');

function fetchRejectionReasons({ item }) {
  const url = 'Advertiser/Customers()/Accounts()/Assets/GetEditorialReasons';
  return odata.post(url, {
    Entities: JSON.stringify({ [item.Asset.Id]: item.Asset.AssetType }),
  });
}

export function getReasonTemplates({
  item, i18n, permissions, scope,
}) {
  return new Promise((resolve) => {
    fetchRejectionReasons({ item }).then((data) => {
      if (!data || _.isEmpty(data) || _.isEmpty(data[0].Reasons)) resolve([i18n.getString('NoRejectionReasonFound')]);

      const options = {
        reasons: data[0].Reasons,
        editorialRejection,
        errI18n,
        i18n: commonI18n,
        locationI18n,
        commonI18n,
        entity: ENTITY.ASSET,
        deliveryStatus: item.EditorialStatus,
        isAppealable: data[0].IsAppealable,
        permissions,
        hideParentLevel: true,
        scope,
      };
      const reasonTemplates = getEditorialTemplates(options);

      resolve(reasonTemplates);
    });
  });
}
